import { Link } from "react-router-dom";

import notreVision from "../assets/notre-vision.jpg";
import specialiste1 from "../assets/notre-vision.jpg";
import specialiste2 from "../assets/specialiste-1.png";
import specialiste3 from "../assets/specialiste-3.png";
import Waveform from "../components/Waveform";
import PromoVideo from "../components/PromoVideo";

export default function Home() {
  return (
    <>
      {/* HERO */}

      <section className="hero-section section">
        <div className="hero-blob" />
        <div className="container position-relative">
          <div className="row align-items-stretch gy-5">
            <div className="col-lg-6 d-flex" data-aos="fade-right">
              <div className="h-100 d-flex flex-column justify-content-center">
                <span className="eyebrow">
                  Services informatiques pour cliniques et entreprises
                </span>

                <h1 className="fw-900 mt-3 display-4">
                  L'expertise TI des cliniques dentaires. La fiabilité pour
                  toutes les PME.
                </h1>

                <p className="lead text-secondary mt-3">
                  CPUc se positionne comme votre expert en technologies pour les
                  cliniques dentaires, d'implantologie, de chirurgie
                  maxillo-faciale et de nombreuses autres spécialités du domaine
                  de la santé bucco-dentaire. Nous comprenons les réalités
                  uniques de ce secteur et prenons en charge l'ensemble de votre
                  environnement technologique afin que vous puissiez vous
                  concentrer sur vos patients. Cette expertise acquise dans un
                  milieu exigeant bénéficie également aux PME de tous horizons
                  qui recherchent un partenaire informatique rigoureux,
                  accessible et humain.
                </p>
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <Link
                    to="/contact"
                    className="btn btn-brand btn-lg rounded-pill px-4"
                  >
                    Discuter de mon projet
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-6 d-flex" data-aos="fade-left">
              <div className="section-img w-100 h-100 d-flex align-items-center">
                <img
                  src={specialiste1}
                  alt="Salle d'attente d'une clinique dentaire équipée par CPUc"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VIDÉO DE PRÉSENTATION */}
      <PromoVideo />

      {/* SPÉCIALISÉS CLINIQUES DENTAIRES ET PME */}
      <section className="section bg-cream">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6 order-lg-2" data-aos="fade-left">
              <div className="section-img">
                <img
                  src={specialiste2}
                  alt="Salle d'attente d'une clinique dentaire équipée par CPUc"
                />
              </div>
            </div>
            <div className="col-lg-6 order-lg-1" data-aos="fade-right">
              {/* <span className="eyebrow">Notre clientèle</span> */}
              <h2 className="fw-900 mt-3">
                Une expertise forgée dans des environnements exigeants
              </h2>
              <p className="text-secondary mt-3">
                Nous accompagnons des organisations où la fiabilité des
                systèmes, la sécurité des données et la continuité des
                opérations sont essentielles. Cette expérience nous permet
                d'offrir à tous nos clients des solutions technologiques
                robustes, adaptées à leur réalité et soutenues par un service de
                proximité.
              </p>
              <Link to="/a-propos" className="fw-bold text-decoration-none">
                Faire connaissance avec notre équipe{" "}
                <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* APERÇU SERVICES */}
      <section className="section">
        <div className="container">
          <div className="row">
            <div className="col-lg-7" data-aos="fade-up">
              <span className="eyebrow">Nos services</span>
              <h2 className="fw-900 mt-3">
                Une seule équipe pour toute votre informatique
              </h2>
              <p className="text-secondary mt-3">
                Des petits dépannages aux grands projets d'infrastructure, on
                s'occupe de tout — maintenance, sécurité, cloud Microsoft et
                bien plus, pour les cliniques comme pour toutes les PME que nous
                accompagnons.
              </p>
            </div>
          </div>

          <div className="row g-4 mt-3">
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="0">
              <div className="service-card p-4">
                <div className="service-icon mb-3">
                  <i className="bi bi-tools"></i>
                </div>
                <h3 className="h5 fw-bold">Maintenance et support</h3>
                <p className="text-secondary mb-0">
                  Assistance à distance ou sur place pour résoudre rapidement
                  vos problèmes informatiques, sans perturber vos rendez-vous.
                </p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
              <div className="service-card p-4">
                <div className="service-icon mb-3">
                  <i className="bi bi-shield-check"></i>
                </div>
                <h3 className="h5 fw-bold">Sécurité informatique</h3>
                <p className="text-secondary mb-0">
                  Protection de vos dossiers patients et surveillance de vos
                  réseaux pour prévenir les menaces.
                </p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="service-card p-4">
                <div className="service-icon mb-3">
                  <i className="bi bi-microsoft"></i>
                </div>
                <h3 className="h5 fw-bold">Solutions cloud Microsoft</h3>
                <p className="text-secondary mb-0">
                  Microsoft 365 et Azure, déployés et gérés pour votre clinique.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4" data-aos="fade-up">
            <Link
              to="/services"
              className="btn btn-outline-brand rounded-pill px-4"
            >
              Voir tous nos services
            </Link>
          </div>
        </div>
      </section>

      {/* TÉLÉPHONIE IP — bandeau vedette (masqué pour le moment) */}
      {false && (
        <section className="section">
          <div className="container">
            <div className="featured-card p-4 p-md-5" data-aos="zoom-in">
              <div className="row align-items-center gy-4">
                <div className="col-lg-6">
                  <span className="badge-new rounded-pill px-3 py-2 badge-pulse">
                    Nouveau
                  </span>
                  <h2 className="fw-900 mt-3" style={{ color: "#fff" }}>
                    La téléphonie IP, version CPUc
                  </h2>
                  <p className="mt-3" style={{ color: "#C7C7CC" }}>
                    Remplacez votre central téléphonique traditionnel par une
                    solution infonuagique flexible, mobile et économique — vos
                    numéros actuels sont conservés, sans interruption de
                    service.
                  </p>

                  <div className="my-3" style={{ maxWidth: "220px" }}>
                    <Waveform height={36} />
                  </div>

                  <div className="d-flex flex-wrap gap-3">
                    <Link
                      to="/telephonie-ip"
                      className="btn btn-brand rounded-pill px-4"
                    >
                      Découvrir la solution{" "}
                      <i className="bi bi-arrow-right ms-1"></i>
                    </Link>
                    <Link
                      to="/offres"
                      className="btn btn-outline-light rounded-pill px-4"
                    >
                      Voir l'offre en cours
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="section-img">
                    <img
                      src={specialiste3}
                      alt="Poste téléphonique IP installé sur un bureau de bureau médical"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ACTUALITÉS — teaser (masqué pour le moment) */}
      {false && (
        <section className="section pt-0">
          <div className="container">
            <div className="row align-items-end mb-4">
              <div className="col" data-aos="fade-up">
                <span className="eyebrow">Actualités</span>
                <h2 className="fw-900 mt-3 mb-0">Ce qui se passe chez CPUc</h2>
              </div>
              <div className="col-auto d-none d-md-block" data-aos="fade-up">
                <Link to="/actualites" className="fw-bold text-decoration-none">
                  Toutes les actualités{" "}
                  <i className="bi bi-arrow-right ms-1"></i>
                </Link>
              </div>
            </div>

            <div className="row g-4">
              <div
                className="col-md-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay="0"
              >
                <div className="news-card p-4 h-100">
                  <span className="news-date">12 juin 2026</span>
                  <span className="news-tag ms-2">Téléphonie IP</span>
                  <h3 className="h6 fw-bold mt-3">
                    Déploiement complet de la téléphonie IP chez une nouvelle
                    clinique
                  </h3>
                  <p className="text-secondary small mb-0">
                    Transfert de numéros, configuration des postes et formation
                    du personnel — réalisé en moins d'une semaine.
                  </p>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="news-card p-4 h-100">
                  <span className="news-date">20 mai 2026</span>
                  <span className="news-tag ms-2">Partenariat</span>
                  <h3 className="h6 fw-bold mt-3">
                    Nouveau partenariat avec Ubiquiti pour la gestion de réseaux
                  </h3>
                  <p className="text-secondary small mb-0">
                    Des réseaux Wi-Fi et filaires encore plus performants,
                    supervisés à distance.
                  </p>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="news-card p-4 h-100">
                  <span className="news-date">8 mai 2026</span>
                  <span className="news-tag ms-2">Téléphonie IP</span>
                  <h3 className="h6 fw-bold mt-3">
                    La téléphonie IP maintenant offerte en mode multi-sites
                  </h3>
                  <p className="text-secondary small mb-0">
                    Un seul système, des numéros locaux pour chaque succursale.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center mt-4 d-md-none" data-aos="fade-up">
              <Link
                to="/actualites"
                className="btn btn-outline-brand rounded-pill px-4"
              >
                Toutes les actualités
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* SIMPLICITÉ — teaser */}
      <section className="section bg-brand-soft">
        <div className="container text-center" data-aos="fade-up">
          <i
            className="bi bi-quote text-brand"
            style={{ fontSize: "2.5rem" }}
          ></i>
          <p
            className="fs-4 fw-bold mb-2"
            style={{ maxWidth: "720px", margin: "0 auto" }}
          >
            Chez CPUc Solutions Technologiques, on transforme vos défis
            informatiques en solutions simples et efficaces.
          </p>
          <Link to="/simplicite" className="fw-bold text-decoration-none">
            Notre philosophie <i className="bi bi-arrow-right ms-1"></i>
          </Link>
        </div>
      </section>
    </>
  );
}
